import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, Stack, Typography } from '@mui/material';
const Card = ({ title, value, Icon, color }) => {
    return (_jsx(Paper, Object.assign({ elevation: 1, sx: {
            padding: '16px',
            backgroundColor: color,
            borderRadius: '8px',
            flexGrow: 1,
        } }, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [_jsx(Icon, {}), _jsx(Typography, Object.assign({ variant: "h5", ml: '16px', sx: { color: '#6B778C', flexGrow: 1 } }, { children: title })), _jsx(Typography, Object.assign({ variant: "h2", sx: { fontWeight: 500 } }, { children: value }))] })) })));
};
export default Card;
